import { AbstractControl, ValidationErrors } from '@angular/forms';

export function lengthEqualTo(length: number | number[]) {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;
    
    const value = control.value;

    length = Array.isArray(length) ? length : [length];

    length.push(0);

    if (Array.isArray(length)) {
      return length.includes(value?.length) ? null : { lengthEqualTo: true };
    } else {
      return value?.length === length ? null : { lengthEqualTo: true };
    }
  };
}
